var url = "d15e2bd0368f7dca3c7d1dccab0fc38a.svg";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;